module.exports = __webpack_public_path__ + "img/Briefe.f2ae2e46.jpg";